<script lang="ts">
    import Loader from "./Loader.svelte"
    import { onMount } from "svelte"
    export let loaded: boolean
    /**
     * Minimum load time, good for letting animations finish
     */
    export let buffer: number = 0

    export let wrapperID = ""

    export let messages: TimedMessage[] = []

    let message = ""

    type TimedMessage = {
        deltatime: number
        html: string
    }

    let timer: number

    function setNextTimeout(thisIndex: number) {
        if (thisIndex in messages) {
            const thisMessage = messages[thisIndex]
            message = thisMessage.html
            timer = setTimeout(() => {
                setNextTimeout(thisIndex + 1)
            }, thisMessage.deltatime)
        }
    }

    onMount(() => (messages.length ? setNextTimeout(0) : null))

    $: if (loaded) clearTimeout(timer)

    // Should take into account true loaded and apply the buffer on top of it
    let bufferLoaded = loaded

    let blocked = false
    $: {
        if (!loaded && buffer) {
            blocked = true
            setTimeout(() => {
                blocked = false
            }, buffer)
        }
    }

    $: bufferLoaded = loaded && !blocked
</script>

{#if bufferLoaded}
    <slot />
{:else}
    <Loader {wrapperID} {message} {...$$restProps} />
{/if}
